<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mJtvmz/tc-custom/9781429904803.jpg?1731883366413" alt="This image is the cover for the book Wrigleyville"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wrigleyville
      </h1>
      <p class="bookDescription body article font2">
        <p><b>For celebrated </b><b>sportswriter</b><b> Peter Golenbock,</b><i><b>Wrigleyville </b></i><b>is a symbol of America's fidelity to its greatest sport. </b><br/><br/>As he did with classics of sports literature, <i>Bums</i> (a history of the Brooklyn Dodgers) and <i>Dynasty </i>(a history of the New York Yankees), Golenbock turns to a team that has won and broken the hearts of generations of fans; the Chicago Cubs.  Utilizing dozens of personal interviews with players, coaches, fans, sportswriters, and clubhouse personnel, as well as out-of-print memoirs by nineteenth-century players, Peter Golenbock has created a perfect gift for every baseball fan: a book that entertains, warms the heart, and touches the soul. <br/><br/>This updated edition includes material on Harry Caray's death, the magical seasons of Sammy Sosa and Kerry Wood, and the Cubs' 1998 playoff dive.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Golenbock
      </h2>
      
      <p class="authorDescription body article"><P><B>Peter Golenbock </B>is the author or coauthor of twenty previous books, including the <I>New York Times</I> bestsellers <I>The Bronx Zoo</I> and <I>Number 1</I>, and more recently, <I>Cowboys Have Always Been My Heroes.</I> He lives in Florida.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4220f5ed